import { Component, HostBinding } from '@angular/core';
import { theme } from '../../../../../data/theme';

@Component({
    selector: 'app-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss'],
})
export class NewsletterComponent {
    @HostBinding('class.footer-newsletter') classFooterNewsletter = true;

    theme = theme;

    socialLinks = [
        {type: 'facebook',  url: 'http://www.facebook.com', icon: 'fab fa-facebook-f'},
        {type: 'twitter',   url: 'http://www.twitter.com', icon: 'fab fa-twitter'},
        {type: 'youtube',   url: 'http://www.youtube.com', icon: 'fab fa-youtube'},
        {type: 'instagram', url: 'http://www.instagram.com', icon: 'fab fa-instagram'},
        {type: 'rss',       url: 'http://www.rss.com', icon: 'fas fa-rss'},
    ];

    constructor() { }
}
